// src/services/api.js
const API_URL = process.env.REACT_APP_API_URL || 'https://football-tracker-api.mehulsaini675.workers.dev';

export const api = {
  // Auth
  async login(username, password) {
    const response = await fetch(`${API_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Login failed');
    }
    
    return response.json();
  },

  // Get matches
  async getMatches(token) {
    const response = await fetch(`${API_URL}/api/matches`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
    
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Failed to fetch matches');
    }
    
    return response.json();
  },

  // Get players
  async getPlayers(token) {
    const response = await fetch(`${API_URL}/api/players`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
    
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Failed to fetch players');
    }
    
    return response.json();
  },

  // Create match
  async createMatch(token, matchData) {
    console.log('API: Creating match with data:', matchData);
    
    const response = await fetch(`${API_URL}/api/matches`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(matchData)
    });
    
    if (!response.ok) {
      const data = await response.json();
      console.error('API: Match creation failed:', data);
      throw new Error(data.error || 'Failed to create match');
    }
    
    const result = await response.json();
    console.log('API: Match created successfully:', result);
    return result;
  },

  // Delete match
  async deleteMatch(token, matchId) {
    console.log('API: Deleting match:', matchId);
    
    const response = await fetch(`${API_URL}/api/matches/${matchId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    
    if (!response.ok) {
      const data = await response.json();
      console.error('API: Delete match failed:', data);
      throw new Error(data.error || 'Failed to delete match');
    }
    
    const result = await response.json();
    console.log('API: Match deleted successfully');
    return result;
  },

  // Delete player
  async deletePlayer(token, playerId) {
    const response = await fetch(`${API_URL}/api/players/${playerId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    
    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Failed to delete player');
    }
    
    return response.json();
  },

  // Create player
  async createPlayer(token, name, position) {
    const response = await fetch(`${API_URL}/api/players`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ name, position })
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Failed to add player');
    }

    return response.json();
  },

  // Get all users (admin only)
  async getUsers(token) {
    const response = await fetch(`${API_URL}/api/users`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Failed to fetch users');
    }

    return response.json();
  },

  // Reset a user's password
  async resetUserPassword(token, userId, password) {
    const response = await fetch(`${API_URL}/api/users/${userId}/password`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ password })
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Failed to reset password');
    }

    return response.json();
  },

  // Delete a user
  async deleteUser(token, userId) {
    const response = await fetch(`${API_URL}/api/users/${userId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Failed to delete user');
    }

    return response.json();
  },

  // Register a new user (admin only)
  async registerUser(token, username, password, role) {
    const response = await fetch(`${API_URL}/api/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ username, password, role })
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || 'Failed to create user');
    }

    return response.json();
  }
};
